import { useAtomValue } from 'jotai';

import { participantsAtom } from '../../video-sdk';
import { RemoteParticipantGridLegacy, RemoteParticipantGridLegacyProps } from './RemoteParticipantGridLegacy';

export function RemoteParticipantGridLegacyWrapper({
  remoteParticipantComponent: RemoteParticipantComponent,
}: Pick<RemoteParticipantGridLegacyProps, 'remoteParticipantComponent'>) {
  const participants = useAtomValue(participantsAtom);

  return (
    <RemoteParticipantGridLegacy
      remoteParticipants={participants}
      remoteParticipantComponent={RemoteParticipantComponent}
    />
  );
}
